import React from 'react';

const Uganda1_ordinary_secondary_his = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_ordinary_secondary_his;
